import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { getPagesContainer } from "../../FeatureCard/utils/getPagesContainer";
import { getResourceUrl } from "../../FeatureCard/utils/getResourceUrl";
import { useWidgetConfiguration } from "./useWidgetConfiguration";
import { WidgetType } from "../../FeatureCard/types";

export const usePageConfig = (type: WidgetType) => {
  const { t } = useTranslation("featureCard");
  const config = useWidgetConfiguration(type);
  const pagesContainer = getPagesContainer(config.children);

  const getPageTitle = useCallback(
    (pageIndex = 0) => pagesContainer?.children[pageIndex]?.options?.title || `${t("page")} ${pageIndex + 1}`,
    [pagesContainer?.children, t],
  );

  const getPageImage = useCallback(
    (pageIndex = 0) => getResourceUrl(pagesContainer?.children[pageIndex]?.options?.image),
    [pagesContainer?.children],
  );

  const getPageIcon = useCallback(
    (pageIndex = 0) => getResourceUrl(pagesContainer?.children[pageIndex]?.options?.icon),
    [pagesContainer?.children],
  );

  return {
    getPageTitle,
    getPageImage,
    getPageIcon,
  };
};
